// extracted by mini-css-extract-plugin
export var container = "_5n-0";
export var icon = "_5n-1";
export var text = "_5n-2";